<!-- @format -->

<mat-toolbar style="display: flex">
  <!-- <fa-icon icon="shopping-bag" class="headerIcon"></fa-icon> -->
  <span>{{ _common.MySpaces }}</span>

  <div class="flex-auto"></div>

</mat-toolbar>
<div class="ctlSearchBar">
  <div class="searchField">
    <fa-icon matPrefix icon="search" class="searchIcon"></fa-icon>
    <input matInput (keyup)="applyFilter($any($event.target).value)" placeholder="{{ _common.search }}" #_search />
    <fa-icon icon="times" matSuffix (click)="clearFilter(_search)" class="clearSearch"></fa-icon>
  </div>

  <!-- <div class="app-filter-bar">
    <div>
      <fa-icon icon="sliders-h"></fa-icon>
    </div>
    <div class="content">
      <app-filter-multi
          [filter]="status"
          #_status
          (change)="refresh()"
          [values]="[
            statusList.published,
            statusList.draft,
            statusList.expired,
            statusList.scheduled
          ]"
          [common]="_common.pricingRuleStatus"
          >{{ _common.Status }}</app-filter-multi
        >
    </div>
    <div (click)="filterObject.openFilter()" class="openFilter">
      <fa-icon icon="ellipsis-h"></fa-icon>
    </div>
  </div>
  <div class="app-btn btn-icon" (click)="refresh()">
    <fa-icon icon="sync"></fa-icon>
  </div> -->

  <span class="spacer"></span>
  <button class="app-btn btn-outline" (click)="exportList()">
    <fa-icon icon="download"></fa-icon> {{ _common.export }}
  </button>
  <span *ngIf="session.hasPermission(permissions.SPACE_ADD)">
    <button class="app-btn" (click)="add()" color="primary" style="background-color: black">
      <fa-icon icon="plus"></fa-icon> {{ _common.add }}
    </button>
  </span>
</div>

<app-scroll-container [more]="hasMore()" (scrolled)="handleScroll($event)" class="max-scroll card-shadow" #scroll>
  <table mat-table [dataSource]="objects" class="app-table scroll" matSort (matSortChange)="sortData($event)">
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row" class="datatable-select">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="image">
      <th mat-header-cell *matHeaderCellDef>
        {{ _common.Spaces }} ({{ rowCount }})
      </th>
      <td mat-cell *matCellDef="let element" style="width: 120px">
        <img [src]="spaceImage(element, element.images[0], true)"
          style="width: 120px; height: 80px; object-fit: cover" />
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="name">
        <!--{{ _common.name }}-->
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="flex gap-2">
          <div>
            <fa-icon icon="check-circle" *ngIf="element.active" style="color: green"></fa-icon>
            <fa-icon icon="times-circle" *ngIf="!element.active" style="color: #ccc"></fa-icon>
          </div>
          <div *ngIf="element.active && element.bookingMode">
            <fa-icon matTooltip="{{ _common.auto_approve_on }}" icon="calendar-check" *ngIf="element.autoApprove"
              style="color: green"></fa-icon>
            <fa-icon matTooltip="{{ _common.auto_approve_off }}" icon="calendar-xmark" *ngIf="!element.autoApprove"
              style="color: #ccc"></fa-icon>
          </div>
        </div>
        <!--#{{ element.id }}-->
        <div class="font-bold">{{ lang(element.name, element.name_lang) }}</div>
        <ng-container *ngIf="element.bookingMode">
          <div *ngIf="element.staffOnly">
            <div class="app-chip" style="background: black;">
              {{_common.staff_only}}
            </div>

          </div>
          <div class="line_item" *ngIf="element.maxBookings > 1">
            <span style="color: #707070" class="text-xs">
              *{{_common.booking_qty_title}}: {{element.maxBookings}}
            </span>

          </div>
        </ng-container>
        <ng-container *ngIf="!element.bookingMode">{{_common.booking_mode}}: {{_common.Off}}</ng-container>

      </td>
    </ng-container>
    <!--<ng-container matColumnDef="organization">
      <th mat-header-cell *matHeaderCellDef>Organization</th>
      <td mat-cell *matCellDef="let element">
        {{ element.location?.organization?.name }}
      </td>
    </ng-container>-->
    <ng-container matColumnDef="location">
      <th mat-header-cell *matHeaderCellDef>{{ _common.center }}</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.location; let location">
          <div style="color: #707070; font-size: smaller">
            {{
            lang(
            location?.organization?.name,
            location?.organization?.name_lang
            )
            }}
          </div>
          {{ lang(location?.name, location?.name_lang) }}
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="purpose">
      <th mat-header-cell *matHeaderCellDef>
        {{ _common.DefualThemes }}
      </th>
      <td mat-cell *matCellDef="let element">
        <div>
          {{ lang(element.purpose?.name, element.purpose?.name_lang) }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="types">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="types">
        {{ _common.Categories }}
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="flex">
          <div *ngFor="let t of element.types" class="spaceType-tags flex">
            <div>
              {{ lang(t.name, t.name_lang) }}
            </div>
          </div>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="locked">
      <th mat-header-cell *matHeaderCellDef>{{ _common.smart_lock }}</th>
      <td mat-cell *matCellDef="let element">
        <div style="width: 20px; text-align: center;">
          <fa-icon icon="circle-check" *ngIf="element.locked" style="color: green"></fa-icon>

        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="capacity">
      <th mat-header-cell *matHeaderCellDef>{{ _common.capacity }}</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.capacity && element.capacity > 0">
          {{element.capacity}}
        </ng-container>
        <ng-container *ngIf="!element.capacity || element.capacity === 0">
          ∞
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="controls" stickyEnd>
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="floating-buttons">
        <button class="app-btn btn-text" (click)="selectObject(element)">
          <fa-icon icon="pen"></fa-icon>
          <div class="mobile_hide">
            {{ _common.edit }}
          </div>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="datatable-row"></tr>
  </table>
</app-scroll-container>

<div *ngIf="filterObject.showFilter" class="ctlFilter listFilter" (clickOutsidePopup)="filterObject.closeFilter()">
  <div class="header">
    <div class="title">
      <fa-icon icon="sliders-h" style="margin-right: 5px"></fa-icon>
      {{ _common.filters }}
    </div>
    <div class="spacer"></div>
    <div (click)="filterObject.closeFilter()" style="font-size: 1.5em; cursor: pointer">
      <fa-icon icon="times"></fa-icon>
    </div>
  </div>
  <div class="body"></div>
  <div class="buttons">
    <div (click)="filterObject.clear(); refresh()" class="clear_button">
      {{ _common.ClearAll }}
    </div>
  </div>
</div>